<div class="container" [ngClass]="{'ps-0': !isReadMode}">
    <ng-container *ngIf="isReadMode; else writeMode" >
        <!-- Read mode -->
        <span *ngIf="isSelected">{{ displayText }}</span>
    </ng-container>
    <ng-template #writeMode>

    <!-- Custom radio template provided -->
    <ng-container *ngIf="radioBtnsTemplate; else defaultRadio">
        <mat-radio-button
            color="primary"
            [value]="value ?? displayText"
            [checked]="isSelected"
            [disabled]="effectiveDisabled"
            (change)="onSelectionChanged()"
            (blur)="onBlur()">
        <ng-container
            *ngTemplateOutlet="radioBtnsTemplate">
        </ng-container>
        </mat-radio-button>
    </ng-container>

    <!-- Default radio button -->
    <ng-template #defaultRadio>
        <mat-radio-button
            color="primary"
            [value]="value ?? displayText"
            [checked]="isSelected"
            [disabled]="effectiveDisabled"
            (change)="onSelectionChanged()"
            (blur)="onBlur()">
            {{ displayText }}
        </mat-radio-button>
    </ng-template>

</ng-template>
</div>